import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class MRErrorMixin extends Vue {
  hasError() {
    const errors = this.$store.state.entities.mr.error;
    return !(!errors || !errors.length);
  }
}

export default MRErrorMixin;